import * as styles from "./Meter.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Meter as BaseMeter } from "@base-ui/react/meter";

import type { MeterProps } from "./Meter.types";

export function Meter({ className, ...props }: MeterProps): JSX.Element {
  return (
    <BaseMeter.Root
      data-slot="meter"
      className={clsx(styles.root, className)}
      {...props}
    />
  );
}
